import {load as loadDashboard} from './dashboard';
import {load as loadDocuments} from './documents';
import {load as loadForms} from './forms';
import {load as loadNotices} from './notices';
import {load as loadQuoting} from './quoting';
import {load as loadReports} from './reports';
import {load as loadRoster} from './roster';
import router from './router';
import {load as loadTraining} from './training';

export const load = (app) => {
	app.config(router);

	loadDashboard(app);
	loadDocuments(app);
	loadForms(app);
	loadNotices(app);
	loadQuoting(app);
	loadReports(app);
	loadRoster(app);
	loadTraining(app);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/index.js